import { useMemo } from 'react'
import { useAuth } from 'user-auth'
import { useMap } from '~map-preview/states/map'

export const useIsWorkspaceMember = () => {
  const { user } = useAuth()
  const map = useMap()

  const isWorkspaceMember = useMemo(() => {
    if (!map || !Object.keys(map).length) return false
    if (!user) return false

    return map.workspace.memberCollection.items.some(
      (member) => member.user.id === user.id
    )
  }, [map, user])

  return isWorkspaceMember
}
